export const styles = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    border: '1px solid #E2E2FC',
    padding: '4px 0px',
    margin: 0,
    marginBottom: 10,
    justifyContent: 'space-between',
  },

  dateColumn: {
    padding: '0 0 0 10px',
    fontSize: 14,
    fontWeight: 400,
  },

  missionColumn: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  },

  buttonColumn: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  },

  deleteButton: {
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    width: 16,
    height: 16,
  },
  arrowButton: {
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
  },
}
